import { yupResolver } from "@hookform/resolvers/yup";
import { Button, SelectItem } from "@heroui/react";
import {
  useCreate,
  useInvalidate,
  useList,
  useNavigation,
  useNotification,
  useUpdate,
} from "@refinedev/core";
import React, { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Asserts } from "yup";
import * as yup from "yup";
import { useAssociationUserShow } from "../../../context/user-show.context";
import { useFileEntityUrl } from "../../../hooks";
import { ApiSdk } from "../../../lib/api-sdk";
import { ResourceIdentifier } from "../../../resources";
import {
  AssociationUser,
  ChangeRequest,
  CreateChangeRequestDto,
  User,
} from "../../../sdk";
import { ImageDropzone } from "../../image-dropzone/image-dropzone";
import { Banner } from "../../ui/banner";
import { FormInputList } from "../../ui/form/form-input-list";

export type UpsertUserFormProps = {
  user?: AssociationUser;
};
export const UserUpsertForm: React.FC<UpsertUserFormProps> = ({ user }) => {
  const { associationUser } = useAssociationUserShow();

  const { replace } = useNavigation();

  const { data: changeRequest } = useList<ChangeRequest>({
    resource: ResourceIdentifier.ChangeRequest,
    meta: {
      associationId: associationUser?.association?.id,
    },
    filters: [
      // associationUser: associationUser?.id,
      { field: "type", value: "user-image", operator: "eq" },
      { field: "status", value: "pending", operator: "eq" },
    ],
  });

  const [files, setFiles] = React.useState<null | File[]>(null);
  const invalidate = useInvalidate();
  const { mutateAsync: updateUser } = useUpdate<Partial<User>>({});

  const { mutateAsync: createChangeRequest } =
    useCreate<CreateChangeRequestDto>();

  const schema = yup.object().shape({
    photo: yup.string().nullable(),
    // email: yup.string().email("Must be a valid email").required(),
    // email: yup.string(),
    // firstName: yup.string().required(),
    // firstName: yup.string(),
    // lastName: yup.string().required(),
    // lastName: yup.string(),
    // gender: yup.string(),
    // country: yup.string(),
    // zip: yup.string(),
    // address: yup.string(),
    // city: yup.string(),
    // dateOfBirth: yup.date().nullable(),
    // associationGolfClass: yup
    //   .number()
    //   .transform((value) => (isNaN(value) ? undefined : value))
    //   .notRequired()
    //   .optional()
    //   .nullable(),
    // golfClass: yup
    //   .number()
    //   .transform((value) => (isNaN(value) ? undefined : value))
    //   .notRequired()
    //   .nullable(),
    // coachClass: yup
    //   .number()
    //   .transform((value) => (isNaN(value) ? undefined : value))
    //   .notRequired()
    //   .nullable(),
    certificates: yup.array().notRequired(),
  });

  const form = useForm({
    defaultValues: {
      // email: "",
      photo: "",
      // firstName: "",
      // lastName: "",
      // country: "",
      // zip: "",
      // address: "",
      // city: "",
      // gender: "male",
      // dateOfBirth: null,
      // role: null,
      // associationGolfClass: undefined,
      // golfClass: undefined,
      // coachClass: undefined,
      certificates: [],
    } as Asserts<typeof schema>,
    values: {
      // email: associationUser?.user?.email || "",
      photo: associationUser?.user?.photoId || "",
      // firstName: associationUser?.user?.firstName || "",
      // lastName: associationUser?.user?.lastName || "",
      // country: associationUser?.user?.country || "",
      // zip: associationUser?.user?.zip || "",
      // address: associationUser?.user?.address || "",
      // city: associationUser?.user?.city || "",
      // gender: associationUser?.user?.gender || "male",
      // dateOfBirth: (associationUser?.user?.dateOfBirth as any) || null,
      // associationGolfClass:
      //   associationUser?.associationGolfClass?.id.toString() as any,
      // golfClass: associationUser?.golfClass?.id.toString() as any,
      // coachClass: associationUser?.coachClass?.id.toString() as any,
      certificates: associationUser?.certificates?.map((el) => {
        return {
          value: el.name,
          id: el.id,
        };
      }),
    },
    resolver: yupResolver(schema),
  });

  const { open } = useNotification();
  const { goBack } = useNavigation();

  const {
    handleSubmit,
    control,
    formState: { errors, isLoading: isFormLoading },
  } = form;

  const [isLoading, setIsLoading] = useState(false);
  const [isImageChanged, setIsImageChanged] = useState(false);

  const upsertAssociationUser = async (data: yup.InferType<typeof schema>) => {
    setIsLoading(true);
    const hasNewImage = files?.[0];
    if (hasNewImage && isImageChanged) {
      const fileEntity = await ApiSdk.files.uploadFile({
        formData: {
          file: files[0],
        },
      });
      data.photo = fileEntity?.id;
    }

    // const dateOfBirth = data.dateOfBirth ? new Date(data?.dateOfBirth) : "";
    // let dateOfBirthString = "";
    // if (dateOfBirth) {
    //   dateOfBirthString = `${dateOfBirth.getFullYear()}-${
    //     dateOfBirth.getMonth() + 1
    //   }-${dateOfBirth.getDate()}
    //   }`;
    // }
    const values = {
      // email: data.email,
      // firstName: data.firstName,
      // lastName: data.lastName,
      // photo: data.photo,
      // gender: data.gender,
      // dateOfBirth: dateOfBirthString,
      // country: data.country,
      // address: data.address,
      // zip: data.zip,
      // city: data.city,
    };

    if (associationUser?.user?.id) {
      try {
        if (form.getFieldState("certificates").isDirty) {
          console.log("Certificates dirty, updating user");
          await updateUser({
            resource: ResourceIdentifier.AssociationUser,
            meta: {
              associationId: associationUser?.association?.id,
            },
            id: associationUser.id,
            successNotification: {
              message: "User profile updated",
              type: "success",
            },
            errorNotification: {
              message: "Error while updating user profile",
              type: "error",
            },
            values: {
              certificates:
                data?.certificates?.map((el) => {
                  return {
                    ...el,
                    name: el.value,
                  };
                }) ?? [],
            },
          });
        } else {
          console.log("Userform not dirty, not updating user");
        }

        console.log({ data, associationUser, hasNewImage });

        if (
          data.photo !== associationUser?.user?.photoId &&
          !(data.photo === "" && associationUser.user.photoId === null)
        ) {
          console.log("Creating change request");
          await createChangeRequest({
            resource: ResourceIdentifier.ChangeRequest,
            successNotification: {
              message: "Sent an image change request to admin",
              description:
                "Once the admin has approved the new image, the image will update automatically",
              type: "success",
            },
            errorNotification: (err) => {
              return {
                type: "error",
                message: "Error while creating image change request",
                description: err?.response?.data?.message,
              };
            },
            meta: {
              associationId: associationUser?.association?.id,
            },
            values: {
              associationUser: associationUser.id,
              association: associationUser?.association?.id,
              from: associationUser?.user?.photoId,
              to: data.photo === "" ? null : data.photo,
              type: "user-image",
            },
          });
        } else {
          console.log("No new image, not creating change request");
        }
        setIsLoading(false);
        replace("/");
      } catch (error) {
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <FormProvider {...form}>
        <form
          className={"h-full py-2"}
          onSubmit={handleSubmit(upsertAssociationUser, (error) => {
            console.log({ error });
          })}
        >
          <div
            className={"flex flex-col justify-between h-full overflow-y-auto"}
          >
            <div className={"flex flex-col gap-4 pb-6 max-w-lg"}>
              <div>
                <h1 className={"text-2xl mb-5"}>User info</h1>
              </div>
              <ImageDropzone
                files={files}
                existingImageUrl={useFileEntityUrl(
                  associationUser?.user?.photoId
                )}
                setFiles={setFiles}
                onClear={() => {
                  form.setValue("photo", "");
                }}
                label={"Select the user avatar"}
                onImageChanged={() => setIsImageChanged(true)}
              />

              {(changeRequest?.data?.length || 0) > 0 && (
                <Banner
                  title={"Image change request pending"}
                  description={
                    "Once the administrator approves your image, the image will update automatically"
                  }
                  variant={"info"}
                ></Banner>
              )}

              {/* <FormInput
              name={"email"}
              label={"Email"}
              disabled={true}
              variant={"bordered"}
              control={control}
            />

            <div className={"flex flex-col gap-4 md:flex-row"}>
              <FormInput
                name={"firstName"}
                label={"First name"}
                variant={"bordered"}
                control={control}
              />
              <FormInput
                name={"lastName"}
                label={"Last name"}
                variant={"bordered"}
                control={control}
              />
            </div>

            <FormDatePicker
              min={"1900-01-01"}
              max={Date.now().toString()}
              label={"Date of birth"}
              name={"dateOfBirth"}
              variant={"bordered"}
              control={control}
            />

            <div className={"flex flex-col gap-4 md:flex-row"}>
              <FormSelect
                label={"Gender"}
                // defaultSelectedKeys={["male"]}
                variant={"bordered"}
                name={"gender"}
                control={control}
              >
                <SelectItem key={"male"} value={"male"}>
                  Male
                </SelectItem>
                <SelectItem key={"female"} value={"female"}>
                  Female
                </SelectItem>
              </FormSelect>
            </div>

            <div className={"flex flex-col gap-4 md:flex-row"}>
              <FormInput
                name={"country"}
                label={"Country"}
                variant={"bordered"}
                control={control}
              />
              <FormInput
                name={"address"}
                label={"Address"}
                variant={"bordered"}
                control={control}
              />
            </div>
            <div className={"flex flex-col gap-4 md:flex-row"}>
              <FormInput
                name={"city"}
                label={"City"}
                variant={"bordered"}
                control={control}
              />

              <FormInput
                name={"zip"}
                label={"Zip"}
                variant={"bordered"}
                control={control}
              />
            </div> */}

              {/* <div className={"flex flex-col gap-4 md:flex-row"}>
              <AssociationGolfClassSelect control={control} />
              <GolfClassSelect control={control} />
            </div> */}
              <div className={"flex flex-col gap-4 md:flex-row"}>
                {/* <CoachClassSelect control={control} /> */}
                <FormInputList
                  name={"certificates"}
                  label={"Certificates"}
                  variant={"bordered"}
                  control={control}
                />
                {/* <CertificatesSelect control={control} /> */}
              </div>
            </div>

            <div className={"space-y-4 mb-4"}>
              <Button
                size={"lg"}
                color={"secondary"}
                type={"submit"}
                fullWidth={true}
                isLoading={isLoading}
                isDisabled={isLoading}
              >
                Save
              </Button>

              <Button
                size={"lg"}
                variant={"bordered"}
                // color={"danger"}
                type={"button"}
                fullWidth={true}
                onPress={() => {
                  goBack();
                }}
              >
                Close
              </Button>
            </div>
          </div>
        </form>
      </FormProvider>
    </>
  );
};
